module.exports = __webpack_public_path__ + "img/bg-club-philosophy.45ca3b7e.jpg";